import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }              from '../shared/shared.module';
import { TableModule }               from '../table/table.module';
import { TemplatedWordingComponent } from './templated-wording.component';
import { TemplatedWordingService }   from './templated-wording.service';

@NgModule({
  declarations: [
    TemplatedWordingComponent
  ],
  entryComponents: [
    TemplatedWordingComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    TemplatedWordingService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class TemplatesModule {}
